import {createDisplayImageField} from '../shared/createDisplayImageField';
import {createImageUploadSectionConfig} from '../shared/displayImageFieldPresets';

export const FREEKICK_ADDITIONAL_IMAGE_FIELDS = [
  createDisplayImageField('missImage', 'Miss'),
  createDisplayImageField('outImage', 'Out'),
  createDisplayImageField('gameOverImage', 'Game Over'),
  createDisplayImageField('goalImage', 'Goal'),
  createDisplayImageField('highBarImage', 'High Bar'),
  createDisplayImageField('rightBarImage', 'Right Bar')
];

export const FREEKICK_ADDITIONAL_SECTION_CONFIG =
  createImageUploadSectionConfig({
    title: 'Additional Images',
    subtitle: 'Visuals displayed across the game.',
    testId: 'additional-images-section',
    downloadButtonId: 'download-sample-image-additional',
    guidelineButtonId: 'view-guideline-additional',
    downloadButtonIcon: 'leading'
  });
